<template>
  <section>
    <div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
      <div class="main-containers">
        <div class="columns">
          <div class="column">
            <h3>Actualizar foto</h3>
          </div>
          <div class="column">
          </div>
          <div>
            <vs-button
                color="primary"
                type="filled"
                class="btn btn-primary btn-group-sm"
                @click="backMenu()">
              Volver a menú
            </vs-button>
          </div>
        </div>
        <hr/>
        <div>
          <div class="is-justify-content-center">
            <div>
              <div class="general-content-margin">
                <div class="columns">
                  <div class="column">
                  </div>
                </div>
                <div class="columns">

                  <div class="column">
                  </div>
                </div>
                <input
                    :hidden="true"
                    v-model="inCodeVehicle = codeVehicle"
                    type="text">
                <input
                    :hidden="true"
                    v-model="inCodeEntity = codeEntity"
                    type="text">
                <input
                    :hidden="true"
                    v-model="inVehicleList = objVehicle"
                    type="text">
                <input
                    :hidden="true"
                    v-model="inPersonList = personList"
                    type="text">
                <input
                    type="file"
                    ref="file"
                    accept="image/*"
                    class="hide"
                    @change="onChangeFile"/>
                <div class="columns">
                  <div class="column">
                    <div class="columns">
                      <div class="column">
                        <h5>Actualizar Foto </h5>
                        <div class="column">
                          <input
                              type="file"
                              ref="file"
                              accept="image/*"
                              class="hide"
                              @change="onChangeFile"/>
                          <img :src="fileName" style="background-color: white"/>
                        </div>
                      </div>
                      <div class="column">
                        <div style="padding: 69px 0 0 0">
                          <div style="margin-bottom: 50px">
                            <vs-button
                                icon="add"
                                color="primary"
                                type="filled"
                                class="btn btn-primary"
                                @click="openExplorer">
                              Adjuntar foto
                            </vs-button>
                          </div>
                          <div>
                            <vs-button
                                icon="add"
                                color="danger"
                                type="filled"
                                class="btn btn-danger"
                                @click="photoDelete">
                              Eliminar foto
                            </vs-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column">

                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <h5>1.Su foto tiene que ser en fondo blanco.</h5>
                    <h5>2.Tiene que tener buena luz de ambiente.</h5>
                  </div>
                  <div>
                    <vs-button
                        color="primary"
                        type="filled"
                        class="btn btn-primary"
                        @click="save()">
                      Actualizar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import {configToast, TOAST_TYPES} from "@/global/toast";
import {GUARDIAN} from "@/global/api/api_guardian";
import {capitalizeFirstLetter, validateExtension} from "@/global/utils";
import {ROUTES} from "@/global/api_routes";

export default {
  name: "UpdatePhoto",
  props: ['objVehicle', 'personList', 'codeEntity', 'codeVehicle'],
  data: () => ({
    name: null,
    lastname: null,
    identification: null,
    company: null,
    photo: [],
    identificationType: "1",
    isLoading: false,
    isDisabled: true,
    inCodeEntity: null,
    inCodeVehicle: null,
    inPersonList: [],
    inVehicleList: [],
    fileName: require('@/assets/images/guardian/user-avatar.png')
  }),

  watch: {
    vehicleList() {
      this.cleanInformation();
    }
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#rates_container");
      return instance.open(message, type);
    },
    backMenu() {
      this.$emit('backMenu', "person");
    },


    photoDelete() {
      this.$refs.file.value = null;
      this.fileName = require('@/assets/images/guardian/user-avatar.png');
    },

    cleanInformation() {
      this.inPersonList = [];
      this.inVehicleList = [];
      this.inCodeVehicle = null;
      this.inCodeEntity = null;
      this.photo = [];
      this.$refs.file.value = null;
      this.fileName = require('@/assets/images/guardian/user-avatar.png');
    },

    transactionCompleted() {
      this.$emit("transactionCompleted", "person")
    },

    openExplorer() {
      this.$refs.file.click();
    },

    getFile() {
      const files = this.$refs.file.files;
      if (!files || files.length == 0) {
        return;
      }
      const file = files[0];
      return file;
    },

    onChangeFile() {
      const file = this.getFile();
      if (!validateExtension(file.name)) {
        this.cleanInformation();
        this.toast("La foto debe contener un formato jpg, png", TOAST_TYPES.ERROR);
        return;
      }
      this.fileName = URL.createObjectURL(file);
    },

    uploadFile() {
      const formData = new FormData();
      const file = this.getFile();
      if (!file) {
        return;
      }
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        this.$http
            .post(ROUTES.GLOBAL.UPLOAD_FILE, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(({data}) => {
              if (data.code > 0) {
                resolve(data.info.code);
                return;
              }
              resolve(null);
            })
            .catch((error) => {
              resolve(null);
            });
      });
    },

    recordPersonList(personList) {
      for (let index = 0; index < personList.length; index++) {
        let person = personList[index];
        let entity = person.entity;
        if (this.inCodeEntity != entity.code) {
          continue;
        }
        return {
          status: person.status,
          code: person.code,
          place: {
            code: person.place.code,
          },
          entity: {
            code: entity.code,
            name: capitalizeFirstLetter(entity.name),
            identification: entity.identification,
            identificationType: entity.identificationType.code,
          },
          photo: this.photo,
          company: {
            code: person.company.code,
          }
        };
      }
    },

    recordVehicleList(inVehicleList) {
      for (let index = 0; index < inVehicleList.length; index++) {
        let vehicles = inVehicleList[index];
        let vehicle = vehicles.vehicle;
        if (this.inCodeVehicle != vehicle.code) {
          continue;
        }
        return {
          status: vehicles.status,
          code: vehicles.code,
          place: {
            code: vehicles.place.code
          },
          vehicle: {
            code: vehicle.code,
            brand: capitalizeFirstLetter(vehicle.brand),
            color: capitalizeFirstLetter(vehicle.color),
            identification: vehicle.identification,
            classification: vehicle.classification.code
          },
          photo: this.photo,
          company: {
            code: vehicles.company.code,
          }
        };
      }
    },

    async save() {
      const files = this.$refs.file.files;
      if (!files || files.length == 0) {
        this.toast("La foto es requerida", TOAST_TYPES.ERROR);
        return;
      }
      this.isLoading = true;
      const fileCode = await this.uploadFile();
      if (fileCode === -1) {
        this.toast(
            "No se pudo subir el archivo correctamente",
            TOAST_TYPES.ERROR
        );
        return;
      }

      if (this.inCodeEntity != null) {
        const entity = this.recordPersonList(this.inPersonList);

        if (fileCode > 0) {
          entity.photo.push(fileCode);
        }

        this.$http.post(GUARDIAN.MANAGE_PERSON.REGISTER_PERSON, entity)
            .then(({data}) => {
              if (data.code > 0) {
                this.transactionCompleted();
                this.isLoading = false;
                this.cleanInformation();
                return;
              }
              this.toast("Verificar los datos ingresados, no se guardó la información");
              this.cleanInformation();
              this.isLoading = false;
            });
      }
      if(this.inCodeVehicle != null){

        const vehicle = this.recordVehicleList(this.inVehicleList);
        this.isLoading = true;

        const fileCode = await this.uploadFile();
        if (fileCode === -1) {
          this.toast(
              "No se pudo subir el archivo correctamente",
              TOAST_TYPES.ERROR
          );
          return;
        }
        if (fileCode > 0) {
          vehicle.photo.push(fileCode);
        }
        this.$http.post(GUARDIAN.MANAGE_PERSON.REGISTER_VEHICLE, vehicle)
            .then(({data}) => {
              if (data.code > 0) {
                this.transactionCompleted();
                this.cleanInformation();
                this.isLoading = false;
                return;
              }
              this.toast("Verificar los datos ingresados, no se guardo la información");
              this.cleanInformation();
              this.isLoading = false;
            });
      }

    }
  }
}
</script>

<style scoped>
.general-content-margin {
  padding: 20px;
}

.main-containers {
  background-color: white;
  padding: 20px;
}

.input-wrapper {
  background-color: white;
  border: 1px solid rgba(34, 51, 84, 0.5);
  border-radius: 4px;
  position: relative;
  padding: 10px;
}

.input-wrapper input {
  border: none;
  position: relative;
  padding: 1px;
  width: 100%;
}

.input-wrapper label {
  position: absolute;
  top: -1.5ex;
  z-index: 1;
  left: 0.4em;
  background-color: white;
  padding: 0 5px;
  color: rgba(34, 51, 84, 0.5);
}

</style>



